import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IPassengerType } from "../../Orchestrator/Types/Interface/IPassengerType";


// Function to get passenger types
export async function getPassengerTypes(showLoader: boolean = true): Promise<IApiResponse<{ answer: IPassengerType[] }>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getPassengerType;
    return await apiRequest<{ answer: IPassengerType[] }>(endpoint, "GET", {}, "none", undefined, undefined, showLoader);
}